import { COLORS } from '@btime/constants'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { HorizontalLine, VerticalLine } from '../../../../../components/shapes/Line'
import { SmallText } from '../../../../../packages/kiti/components/presentation/Text'
import BasicInfo from './BasicInfo'
import EventsList from './events/EventsList'
import EventsLoader from './events/_load/EventsLoader'
import FlexGrid, { FlexCol } from '../../../../../components/structure/FlexGrid'
import Separator from '../../../../../packages/kiti/components/helpers/Separator'

const ServiceOrderDetails = () => {
  const { t } = useTranslation('serviceOrders')
  return (
    <FlexGrid justify="space-between" align="flex-start" paddingGutter={0.5} wrap>
      <FlexCol flex={2} wrapOn="sm">
        <BasicInfo />
      </FlexCol>

      <FlexCol alignSelf="stretch" hideOn="sm">
        <VerticalLine thin lineColor={COLORS.light2} fullHeight />
      </FlexCol>

      <FlexCol alignSelf="stretch" hideOn="mdu" wrapOn="sm">
        <HorizontalLine thin lineColor={COLORS.light2} />
      </FlexCol>

      <FlexCol flex={1}>
        <SmallText bold>{t('show.history')}</SmallText>
        <Separator />
        <EventsLoader>
          <EventsList />
        </EventsLoader>
      </FlexCol>
    </FlexGrid>
  )
}

export default ServiceOrderDetails
